<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <v-select
          v-model="dateRange"
          :disabled="!showDatePicker"
          :items="dateRangeList"
          label="Period"
          hide-details
          class="col-1"
          style="min-width: 250px"
        ></v-select>
        <date-picker
          :disabled="!showDatePicker"
          v-model="tabInfo.from"
          label="Date From"
          style="max-width: 150px"
          class="mx-1"
        />

        <date-picker
          :disabled="!showDatePicker"
          v-model="tabInfo.to"
          label="Date To"
          style="max-width: 150px"
          class="mx-1"
        />

        <div class="mr-3" style="font-size: 12px !important;">
          <div class="mb-0"><label class="v-label v-label--active theme--light body-2">Type:</label></div>
          <v-btn-toggle
            v-model="activeAccount.bonusTab"
            mandatory
            color="primary"
          >
            <v-btn
              small
              value="bonus"
            >
              Bonus
            </v-btn>
            <v-btn
              small
              value="shop"
            >
              Shop
            </v-btn>
            <v-btn
              small
              value="benefits"
            >
              Available Benefits
            </v-btn>
            <v-btn
              small
              value="packages"
            >
              Packages
            </v-btn>
          </v-btn-toggle>
        </div>

        <v-btn color="info" v-on:click="search" class="mt-3">Search</v-btn>
      </v-row>
    </v-card>

    <v-card
      v-if="activeAccount.bonusTab === 'benefits'"
      class="pa-4 mt-4"
    >
      <v-row class="align-center">
        <v-col cols="4">
          <v-select
            v-model="benefitValidation.benefit_id"
            :items="items"
            :loading="benefitValidation.isLoading"
            :error-messages="benefitValidation.errors"
            :error="!benefitValidation.available"
            :error-count="benefitValidation.errors.length"
            label="Benefit"
            item-text="name"
            item-value="benefit_id"
          />
        </v-col>
        <v-col cols="2">
          <v-btn
            v-if="!benefitValidation._hasResult"
            color="primary"
            :loading="benefitValidation.isLoading"
            :disabled="!benefitValidation.benefit_id"
            @click="verifyAvailability"
          >
            Check availability
          </v-btn>
          <v-icon
            v-else
            :color="benefitValidation.available ? 'primary' : 'error'"
          >
            {{ benefitValidation.available ? 'mdi-check' : 'mdi-alert-circle' }}
          </v-icon>
        </v-col>
      </v-row>
    </v-card>


    <v-card class="pa-4 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredTransactions"
        sort-by="created"
        sort-desc


        :item-key="options.itemKey"
        :expanded.sync="options.expanded"
        :show-expand="options.showExpand"


        fixed-header
        hide-default-footer
        :items-per-page="-1"
        calculate-widths
        class="bonus-table"
        style="z-index: 0; position: relative; white-space: nowrap"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-bonus-filter-select"
                :items="columnValueList(header.value)"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-bonus-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
                :style="filters[header.value].style"
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:item.choice="{ item }">
          <span>{{ item.choice.amount.min }} - {{ item.choice.amount.max }}</span>
        </template>
        <template v-slot:item.description="{ item }">
          {{ item.description }}
          <br v-if="item.description && item.rules.type" />
          <template v-if="item.rules.type">
            Type: {{ item.rules.type }}
          </template>
          <template v-if="item.game">
            Game: {{ item.game.name }}
          </template>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="d-flex align-center">
            <div style="max-width: 150px;">
              <v-select
                v-if="checkBonusEdit(item)"
                :items="statuses"
                v-model="item.status"
                @change="updateBonusStatus(item)"
                dense
                hide-details
                small
              />
              <template v-else>
                {{ item.status }}
              </template>
            </div>

            <default-history
              v-if="item.data?.action"
              class="ml-2"
              :items="item.data.action"
              :headers="subHeaders"
              :use-api="false"
              icon="history"
              size="small"
              icon-size="19px"
              title="Action History"
            />
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
          <v-tooltip right v-if="item?.data?.message">
            <template v-slot:activator="{ on }">
              <v-icon
                style="margin-top: -2px;"
                class="ml-2 font-size-21"
                color="warning"
                dark
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>{{ item.data.message }}</span>
          </v-tooltip>


          <v-tooltip
            v-if="activeAccount.bonusTab === 'bonus'"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-icon
                  title=""
                  :color="'info lighten-' + (hover ? 1 : 3)"
                  class="ml-2 font-size-21"
                  style="cursor: pointer;margin-top: -2px;"
                  v-on="on"
                  v-text="'info'"
                />
              </v-hover>
            </template>
            <span>
              Sticky: {{ yesno(item.rules.sticky) }}<br />
              Max Release: {{ item.rules.max_release }}<br />
              <template v-if="item?.rules?.max_freespin_win">
                Max FS Win: {{ item.rules.max_freespin_win }}<br />
              </template>
              <template v-if="item.rules.freespin_value">
                Freespin Value: {{ item.rules.freespin_value }}<br />
              </template>
              Rollover Type: {{ item.rules.rollover_type }}<br />
              Deposit Amount: {{ item.rules.deposit_amount }}<br />
              <template v-if="item?.rules?.bet_limits">
                Bet Limits (Min): {{ item.rules.bet_limits.min }}<br />
                Bet Limits (Max): {{ item.rules.bet_limits.max }}<br />
              </template>
              <template v-if="item.parent_id">
                Parent bonus ID: {{ item.parent_id }}<br />
                Parent bonus name: {{ item.parent_name }}
              </template>
              <template v-if="item.rules.additional_requirements?.length">
                Additional requirements: {{ item.rules.additional_requirements.join(', ') }}
              </template>
            </span>
          </v-tooltip>

          <v-icon
            v-if="activeAccount.bonusTab === 'bonus' && checkBonusEdit(item)"
            small
            class="ml-2"
            style="margin-top: -2px"
            @click.stop="openManualTransactionForItem(item)"
            title="Copy bonus"
          >
            mdi-content-copy
          </v-icon>
        </template>

        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <v-icon
            v-if="item?.rules?.choices"
            @click="expand(!isExpanded)"
          >
            {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length" v-if="item?.rules?.choices">
            <v-row class="col-12 px-0 mx-0 data-table-bonus_expand">
              <v-col cols="6" class="pl-0">
                <fieldset class="px-2 pb-2 group-border">
                  <legend class="px-2">Choices</legend>
                  <v-container class="pa-0 ma-0" v-for="(choice, i) in item.rules.choices" :key="'bt-choice-' + i">
                    <v-divider v-if="i > 0" class="my-4" />
                    <v-card v-for="(bonus, k) in choice.bonuses" :key="'bt-choice-bonus-' + k" class="mt-2">
                      <v-card-text :class="{'pt-2': true, 'pb-2': bonus.type == 'loyalty'}">
                        <v-row>
                          <v-text-field
                            class="col-3 data-table-bonus_expand-type-field"
                            label="Type"
                            :value="bonus.type"
                            hide-details
                            readonly
                          />

                          <v-text-field
                            class="col-2"
                            label="Amount"
                            :value="getAmount(bonus)"
                            :suffix="['casino', 'sport', 'cash_bonus', 'loyalty'].includes(bonus.type) && getAmount(bonus) ? item.currency : null"
                            hide-details
                            readonly
                          />

                          <v-text-field
                            class="col-2 data-table-bonus_expand-wager-field"
                            v-if="bonus.hasOwnProperty('wager')"
                            label="Wager"
                            :value="bonus.wager"
                            hide-details
                            readonly
                          />

                          <v-select
                            v-if="bonus.hasOwnProperty('game_id')"
                            class="col"
                            label="Game"
                            :value="bonus.game_id"
                            :prefix="'#' + bonus.game_id"
                            :items="games"
                            hide-details
                            readonly
                          />

                          <v-checkbox
                            :class="{'mr-3': true, 'mt-0': bonus.hasOwnProperty('game_id'), 'ml-3': bonus.hasOwnProperty('game_id')}"
                            v-if="bonus.hasOwnProperty('brand_exclusive')"
                            label="Excl. Brand"
                            :value="bonus.brand_exclusive"
                            hide-details
                            readonly
                          />

                          <v-checkbox
                            :class="{'mt-0': bonus.hasOwnProperty('game_id')}"
                            v-if="bonus.hasOwnProperty('game_exclusive')"
                            label="Excl. Game"
                            :value="bonus.game_exclusive"
                            hide-details
                            readonly
                          />
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-container>
                </fieldset>

              </v-col>
              <v-col cols="6" class="pr-0">
                <fieldset class="px-2 pb-2 group-border" v-if="item.status === STATUS_GRANTED">
                  <legend class="px-2">Granted</legend>
                  <v-card v-for="(bonus, i) in item.granted" :key="'bt-granted-bonus-' + i" class="mt-2">
                    <v-card-text :class="{'pt-1': !!bonus.name,'pt-2': !bonus.name, 'pb-2': true}">
                      <v-label><small>{{ bonus.name }}</small></v-label>
                      <v-row>
                        <v-text-field
                          class="col-3 bonus_expand-type-field"
                          label="Type"
                          :value="bonus.type"
                          hide-details
                          readonly
                        />

                        <v-text-field
                          class="col-2"
                          label="Amount"
                          :value="getAmount(bonus)"
                          :suffix="['casino', 'sport', 'cash_bonus', 'loyalty'].includes(bonus.type) && getAmount(bonus) ? item.currency : null"
                          hide-details
                          readonly
                        />

                        <v-text-field
                          class="col-2 data-table-bonus_expand-wager-field"
                          v-if="bonus.hasOwnProperty('wager')"
                          label="Wager"
                          :value="bonus.wager"
                          hide-details
                          readonly
                        />

                        <v-select
                          v-if="bonus.hasOwnProperty('game_id')"
                          class="col"
                          label="Game"
                          :value="bonus.game_id"
                          :prefix="'#' + bonus.game_id"
                          :items="games"
                          hide-details
                          readonly
                        />

                        <v-checkbox
                          :class="{'mr-3': true, 'pt-0': true, 'mt-0': bonus.hasOwnProperty('game_id'), 'ml-3': bonus.hasOwnProperty('game_id')}"
                          v-if="bonus.hasOwnProperty('provider_exclusive')"
                          label="Excl. Brand"
                          :value="bonus.provider_exclusive"
                          hide-details
                          readonly
                        />

                        <v-checkbox
                          :class="{'pt-0': true,'mt-0': bonus.hasOwnProperty('game_id')}"
                          v-if="bonus.hasOwnProperty('game_exclusive')"
                          label="Excl. Game"
                          :value="bonus.game_exclusive"
                          hide-details
                          readonly
                        />
                      </v-row>
                    </v-card-text>
                  </v-card>
                </fieldset>

                <fieldset
                  class="px-2 pb-2 group-border"
                  v-else-if="item.status === STATUS_ERROR"
                >
                  <legend class="px-2">Error</legend>

                  <v-card class="mt-2">
                    <v-card-text class="pb-2 pt-1">
                      <template v-if="item.data.error">
                        Error: {{ item.data.error }}
                      </template>
                      <template v-if="item.data.duplicate">
                        Duplicate account: <a :href="'/user-management/' + item.data.duplicate.account_id" target="_blank">{{ item.data.duplicate.account_id }}</a>
                        Benefit id: {{ item.data.duplicate.benefit_id }}
                      </template>
                    </v-card-text>
                  </v-card>
                </fieldset>
              </v-col>
            </v-row>
          </td>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>
<style>

  .data-table-bonus_expand .v-input--checkbox .v-label {
    font-size: 14px;
  }

  .data-table-bonus_expand .bonus_expand-type-field {
    max-width: 125px;
  }

  .data-table-bonus-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-bonus-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }


  .data-table-bonus-filter-textfield {
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .td-bonus-name {
    min-width: 300px;
    white-space: normal;
  }
</style>

<script>

  import { findIndex, find, set, get, cloneDeep } from 'lodash'
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import 'sticky-table-headers'
  import DefaultHistory from '@/components/helper/DefaultHistory.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
  import { makeDateRangeComputed } from '../utils'

  export default {
    components: {
      DefaultHistory,
      DatePicker
    },

    mounted () {

    },

    props: [],
    data: () => ({
      statuses: [
        { text: 'New', value: 'new' },
        { text: 'Active', value: 'active' },
        { text: 'Canceled', value: 'canceled' },
        { text: 'Released', value: 'released' },
        { text: 'Used', value: 'used' },
        { text: 'Expired', value: 'expired' },
        { text: 'Error', value: 'error' },
      ],
      typeMapping: {
        casino: 'bonus',
        freespin: 'freespins',
        sport: 'sport_bonus',
        overdraft: 'overdraft'
      },
      dateRangeList,
      subHeaders: [
        { text: 'Updated', value: 'updated', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Message', value: 'message', sortable: false },
      ],
      headersByType: {
        bonus: [
          { text: 'ID', value: 'bonus_id' },
          { text: 'Name', value: 'name', cellClass: 'td-bonus-name' },
          { text: 'Parent ID', value: 'parent_id' },
          { text: 'Description', align: 'left', sortable: false, value: 'description', },
          { text: 'Amount', value: 'amount', sortable: false, },
          { text: 'Wager', value: 'wager', sortable: false },
          { text: 'Type', value: 'type', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'By', value: 'data.operator_name', sortable: false },
          { text: 'Source', value: 'source', sortable: false },
          { text: 'Created', value: 'created', sortable: false },
          { text: 'Updated', value: 'updated', sortable: false },
          { text: 'Expire', value: 'expire', sortable: false },
          { text: '', value: 'data-table-expand', 'class': 'nowrap' }
        ],
        shop: [
          { text: 'ID', value: 'transaction_id' },
          { text: 'Name', value: 'productName' },
          { text: 'Type', value: 'type', sortable: false },
          { text: 'Price', value: 'price', sortable: false },
          { text: 'Choice Amount Min-Max', value: 'choice', sortable: false },
          { text: 'Amount', value: 'amount', sortable: false },
          { text: 'Categories', value: 'categories', sortable: false },
          { text: 'Created', value: 'created', sortable: false },
          { text: 'Updated', value: 'updated', sortable: false },
        ],
        benefits: [
          { text: 'ID', value: 'benefit_id', class: 'sticky-header' },
          { text: 'RefID', value: 'ref_id', class: 'sticky-header' },
          { text: 'Name', value: 'name', sortable: false, class: 'sticky-header', },
          { text: 'Type', value: 'type', sortable: false },
          { text: 'Trigger', value: 'trigger', sortable: false, class: 'sticky-header' },
          { text: 'Status', value: 'status', sortable: false, class: 'sticky-header' },
          { text: 'Created', value: 'created', sortable: false, class: 'sticky-header' },
          { text: 'Updated', value: 'updated', sortable: false, class: 'sticky-header' },
        ],
        packages: [
          { text: 'ID', value: 'package_id' },
          { text: 'Benefit', value: 'benefit' },
          { text: 'Type', value: 'rules.type', sortable: false },
          { text: 'Recurring', value: 'rules.recurring', sortable: false },
          { text: 'Manual Check', value: 'manual_check', sortable: false },
          { text: 'Status', value: 'status' },
          { text: 'Created', value: 'created' },
          { text: 'Updated', value: 'updated' },
          { text: ' ', value: 'data-table-expand', 'class': 'nowrap' },
          // { text: '', value: 'action' },
        ]
      },

      STATUS_GRANTED: 'granted',
      STATUS_ERROR: 'error',

      benefitValidation: {
        isLoading: false,
        errors: [],
        available: false,
        benefit_id: null,

        _hasResult: false,
      }
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', bonus: 'account/bonus', packages: 'account/packages', shop: 'account/shop', benefits: 'account/benefits' }),

      type: function () {
        const MAPPER_ACTIVE_TAB_TO_ACTIONS = {
          bonus: 'account/loadBonuses',
          packages: 'account/loadPackages',
          shop: 'account/loadShop',
          benefits: 'account/loadBenefits',
          DEFAULT: 'account/loadBonuses'
        }

        return MAPPER_ACTIVE_TAB_TO_ACTIONS[this.activeAccount.bonusTab] || MAPPER_ACTIVE_TAB_TO_ACTIONS.DEFAULT
      },

      headers: function () {
        return this.headersByType[this.activeAccount.bonusTab]
      },

      showDatePicker: function () {
        return this.activeAccount.bonusTab != 'benefits'
      },

      tabInfo: function () {
        return (this[this.activeAccount.bonusTab] || {})
      },

      filters: function () {
        return (this[this.activeAccount.bonusTab] || {}).filters || {}
      },

      items: function () {
        return (this[this.activeAccount.bonusTab] || {}).items || []
      },

      games: function () {
        return (this[this.activeAccount.bonusTab] || {}).games || []
      },

      options: function () {
        return (this[this.activeAccount.bonusTab])?.options || {}
      },

      loading: function () {
        return (this[this.activeAccount.bonusTab] || {}).loading
      },

      filteredTransactions: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            return this.filters[f].data.length < 1 || (this.filters[f].data.includes(d[f]) || (d[f] || '').toString().indexOf(this.filters[f].data) >= 0)
          })
        })
      },

      dateRange: makeDateRangeComputed('tabInfo'),
    },

    methods: {
      yesno: (v) => (v ? 'yes' : 'no'),
      getAmount: function (bonus) {
        if (bonus.amount || bonus.percent) {
          return bonus.amount || (bonus.percent + '%')
        }

        let item = find(bonus.amounts, { currency: this.activeAccount.account.currency })
        if (!item) return null
        return item.amount
      },
      updateBonusStatus: async function (item) {

        const isConfirmed = await this.$root.$confirm('Confirm', 'Do you want change bonus state?', { promptLabel: 'Reason for change?' })

        if (isConfirmed) {

          API.call('/$v/account/bonus/update.json', {
            login: this.activeAccount.account.login,
            account_id: this.activeAccount.account.account_id,
            bonus_id: item.bonus_id,
            status: item.status,
            message: typeof isConfirmed === 'string' ? isConfirmed : ''
          }, this.activeAccount.account).then(resp => {

            this.$nextTick(function () {
              const indexItem = findIndex(this.items, { bonus_id: item.bonus_id })

              this.$set(this.bonus.initItems, indexItem, cloneDeep(resp.data))
              this.$set(this.items, indexItem, cloneDeep(resp.data))
            })

            return resp.data
          }).catch(e => {
          })
        } else {
          this.$nextTick(function () {
            const indexItem = findIndex(this.items, { bonus_id: item.bonus_id })
            this.$set(this.items, indexItem, this.bonus.initItems[indexItem])
          })
        }

      },

      checkBonusEdit: function (item) {
        let typeMap = {
          casino: 'bonus',
          freespin: 'freespins',
          sport: 'sport_bonus',
          respin: 'respin',
          overdraft: 'overdraft',
        }
        if (typeMap[item.type]) {
          return this.$store.state.auth.checkAccess({ key: 'manual_transaction', value: typeMap[item.type] })
        }

        return false
      },

      search: function () {
        this.$store.dispatch(this.type, this.activeAccount.account).catch(e => {
          this.$notification.show = true
          this.$notification.message = e.response.data.message
          this.$notification.type = 'error'
        }).then(r => {
          jQuery('.bonus-table table').stickyTableHeaders()
        })
      },

      columnValueList (val) {
        return this.items.map(d => d[val])
      },

      prepareModalData (item, modalTab) {
        const data = {
          name: item.name,
          status: item.status,
          amount: item.amount,
          ...this.extractRules(item.rules, modalTab),
          ...this.extractExpireData(item.expire),
          ...this.extractGameData(item.game, modalTab)
        }

        return data
      },

      extractRules (rules, modalTab) {
        const data = {}

        if (rules) {
          if (rules.wager) data.wager = rules.wager
          if (rules.rollover_type) data.rollover_type = rules.rollover_type
          if (rules.sticky !== undefined) data.sticky = rules.sticky ? 1 : 0
          if (rules.max_release) data.max_release = rules.max_release
          if (rules.deposit_amount_percent) data.deposit_amount_percent = rules.deposit_amount_percent

          if (rules.exclusive) {
            if (rules.exclusive.game_id) data.game_id_exclusive = rules.exclusive.game_id
            if (rules.exclusive.brand_exclusive) data.brand_exclusive = rules.exclusive.brand_exclusive
            if (rules.exclusive.system_exclusive) data.system_exclusive = rules.exclusive.system_exclusive
          }

          if (rules.bet_limits) {
            data.bet_limits_min = rules.bet_limits.min
            data.bet_limits_max = rules.bet_limits.max
          }

          if (modalTab === 'freespins' && rules.max_freespin_win) data.max_freespin_win = rules.max_freespin_win
          if (modalTab === 'freespins' && rules.freespin_value) data.freespin_value = rules.freespin_value
          if (modalTab === 'sport_bonus' && rules.type) data.bonus_type = rules.type
          if (modalTab === 'sport_bonus' && rules.release_type) data.release_type = rules.release_type
        }

        return data
      },

      extractExpireData (expire) {
        if (!expire) return {}

        const expireDate = new Date(expire)
        return {
          expireDate: expireDate.toISOString().split('T')[0],
          expireTime: expireDate.toTimeString().split(' ')[0]
        }
      },

      extractGameData (game, modalTab) {
        const data = {}

        if (game) {
          if (modalTab === 'freespins' || (game && game.id)) {
            data.game_id = game.id || game.game_id
          }
        }

        return data
      },

      openManualTransactionModal (tabType, data, fromMainView = false) {
        this.$store.dispatch('manual_transaction/open_with_tab', {
          tabType,
          formData: data,
          account: this.activeAccount.account,
          fromMainView
        })
      },

      openManualTransactionForItem (item) {
        if (!item.type) return

        const modalTab = this.typeMapping[item.type]
        if (!modalTab) return

        if (!this.$store.state.auth.checkAccess({ key: 'manual_transaction', value: modalTab })) {
          return
        }

        const modalData = this.prepareModalData(item, modalTab)

        this.openManualTransactionModal(modalTab, modalData, true)
      },

      verifyAvailability() {
        this.benefitValidation.isLoading = true
        return API.call('/$v/account/bonus/verify.json', {
          benefit_id: this.benefitValidation.benefit_id,
          account_id: this.activeAccount.account_id,
          login: this.activeAccount.account.login,
        })
          .then(r => {
            this.benefitValidation._hasResult = true
            this.benefitValidation.errors = r.data.errors
            this.benefitValidation.available = r.data.available
          })
          .finally(() => this.benefitValidation.isLoading = false)
      }
    },

    watch: {
      'benefitValidation.benefit_id': function() {
        if (this.benefitValidation._hasResult) {
          this.benefitValidation._hasResult = false
        }
      }
    }
  }
</script>
